var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2v4M8 2v4M3 9h18m-2-5H5a2 2 0 00-2 2v13c0 1.1.9 2 2 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm-1.77 7.98c.03 0 .05.02.05.05m-3.55-.05c.02 0 .05.02.05.05m-3.56-.05c.03 0 .05.02.05.05m-3.55-.05c.03 0 .05.02.05.05m-.05 2.95c.03 0 .05.02.05.05m3.45-.05c.03 0 .05.02.05.05m3.46-.05c.02 0 .05.02.05.05m3.45-.05c.03 0 .05.02.05.05m-.05 2.95c.03 0 .05.02.05.05m-3.55-.05c.02 0 .05.02.05.05m-3.56-.05c.03 0 .05.02.05.05m-3.55-.05c.03 0 .05.02.05.05",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgYearView;